var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleChevronRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    className: "MuiSvgIcon-root",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.545 20.503a1.49 1.49 0 1 1-2.108-2.108l6.4-6.4-6.4-6.39a1.491 1.491 0 0 1 2.108-2.108l8.51 8.498z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.382 20.503a1.49 1.49 0 0 0 2.109 0L23 11.995l-8.51-8.498a1.49 1.49 0 1 0-2.108 2.108l6.4 6.39-6.4 6.4a1.491 1.491 0 0 0 0 2.108z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleChevronRight);
export default __webpack_public_path__ + "static/media/double-chevron-right.6199c741.svg";
export { ForwardRef as ReactComponent };